__turbopack_context__.v({
  "MuiButtonBase-root-MuiTab-root": "tabbed_menu_pannel-module-scss-module__DBii6G__MuiButtonBase-root-MuiTab-root",
  "columnItem": "tabbed_menu_pannel-module-scss-module__DBii6G__columnItem",
  "gridContainer": "tabbed_menu_pannel-module-scss-module__DBii6G__gridContainer",
  "gridItem": "tabbed_menu_pannel-module-scss-module__DBii6G__gridItem",
  "headerItem": "tabbed_menu_pannel-module-scss-module__DBii6G__headerItem",
  "hideIcon": "tabbed_menu_pannel-module-scss-module__DBii6G__hideIcon",
  "itemBox": "tabbed_menu_pannel-module-scss-module__DBii6G__itemBox",
  "itemIcon": "tabbed_menu_pannel-module-scss-module__DBii6G__itemIcon",
  "itemImage": "tabbed_menu_pannel-module-scss-module__DBii6G__itemImage",
  "itemLabel": "tabbed_menu_pannel-module-scss-module__DBii6G__itemLabel",
  "itemText": "tabbed_menu_pannel-module-scss-module__DBii6G__itemText",
  "newSuperscript": "tabbed_menu_pannel-module-scss-module__DBii6G__newSuperscript",
  "overlayText": "tabbed_menu_pannel-module-scss-module__DBii6G__overlayText",
  "showIcon": "tabbed_menu_pannel-module-scss-module__DBii6G__showIcon",
  "tab": "tabbed_menu_pannel-module-scss-module__DBii6G__tab",
  "tabIcon": "tabbed_menu_pannel-module-scss-module__DBii6G__tabIcon",
  "tabPanel": "tabbed_menu_pannel-module-scss-module__DBii6G__tabPanel",
  "tabbedMenuPanelContainer": "tabbed_menu_pannel-module-scss-module__DBii6G__tabbedMenuPanelContainer",
  "tabsContainer": "tabbed_menu_pannel-module-scss-module__DBii6G__tabsContainer",
});
